// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"DocumentGrid_gridContainer__28_6z","gridOverlay":"DocumentGrid_gridOverlay__13gCo"};